import React from 'react';

const Impressum: React.FC = () => {
    return (
        <div className="container mt-4">
            <h1 className="mb-4">Impressum</h1>
            <p>
                <em>Impressum für den Webauftritt „Frühe Hilfen / FamilienPlus"</em><br />
                <em>Stand: 04.12.2025</em>
            </p>

            <h2>Anbieter und Gesamtverantwortung</h2>
            <p>
                Landratsamt Waldshut<br />
                Kaiserstraße 110<br />
                79761 Waldshut-Tiengen<br />
                Deutschland
            </p>
            <p>
                Telefon: +49 (0) 7751 / 86-0<br />
                Fax: +49 (0) 7751 / 86-1999<br />
                E-Mail: <a href="mailto:post@landkreis-waldshut.de">post@landkreis-waldshut.de</a>
            </p>
            <p>
                Das Landratsamt Waldshut ist eine Körperschaft des öffentlichen Rechts. Es wird vertreten durch den
                Landrat Dr. Martin Kistler.
            </p>
            <p>
                Umsatzsteueridentifikationsnummer: DE142827103
            </p>

            <h2>Organisatorische Zuordnung</h2>
            <p>
                „Frühe Hilfen / FamilienPlus" ist ein Angebot des Jugendamts im Landratsamt Waldshut.
            </p>

            <h2>Kurzbeschreibung des Angebots</h2>
            <p>
                FamilienPlus ist für alle (werdenden) Eltern und Familien mit Kindern bis drei Jahre im Landkreis
                Waldshut. Hier findest du Angebote rund um Schwangerschaft, Eltern werden und Familie sein. Diese Seite
                soll dir dabei helfen, die passenden Angebote für deine Situation und Fragen zu finden.
            </p>

            <h2>Inhaltlich verantwortlich nach § 18 Abs. 2 MStV</h2>
            <p>
                Heribert Thamm, Amtsleiter Jugendamt<br />
                Landratsamt Waldshut, Kaiserstraße 110, 79761 Waldshut-Tiengen<br />
                Telefon: +49 (0) 7751 / 86-4301<br />
                E-Mail: <a href="mailto:jugendamt@landkreis-waldshut.de">jugendamt@landkreis-waldshut.de</a>
            </p>

            <h2>Kontakt „Frühe Hilfen / FamilienPlus"</h2>
            <p>
                Jugendamt – Frühe Hilfen / FamilienPlus<br />
                Im Wallgraben 38<br />
                79761 Waldshut-Tiengen<br />
                Telefon: +49 (0) 7751 / 86-4343<br />
                E-Mail: <a href="mailto:Fruehe.Hilfen@landkreis-waldshut.de">Fruehe.Hilfen@landkreis-waldshut.de</a>
            </p>

            <h2>Webdesign und technische Umsetzung</h2>
            <p>
                CloudHaus GmbH<br />
                Sandweg 10<br />
                38524 Sassenburg
            </p>
            <p>
                E-Mail: <a href="mailto:info@cloudhaus.io">info@cloudhaus.io</a><br />
                Web: <a href="https://www.cloudhaus.io" target="_blank" rel="noopener noreferrer">www.cloudhaus.io</a>
            </p>

            <h2>Aufsichtsbehörde</h2>
            <p>
                Das Landratsamt Waldshut unterliegt der Rechtsaufsicht des Landes Baden-Württemberg.
            </p>

            <h2>Haftung für Inhalte</h2>
            <p>
                Das Landratsamt Waldshut ist als Inhalte-Anbieter im Rahmen des § 7 Abs. 1 des DDG bzw. des § 18 MStV
                für die „eigenen Inhalte" verantwortlich. Die Inhalte wurden nach bestem Wissen sorgfältig erarbeitet
                und geprüft. Es wird jedoch keine Gewähr - weder ausdrücklich noch stillschweigend - für die
                Aktualität, Richtigkeit, Vollständigkeit oder Qualität und jederzeitige Verfügbarkeit der
                bereitgestellten Informationen übernommen. Für Schäden, die durch die Nutzung dieses Internetangebots
                entstehen, wird lediglich im Rahmen der gesetzlichen Bestimmungen gehaftet. Somit sind
                Haftungsansprüche gegen das Landratsamt Waldshut, welche sich auf Schäden materieller und/oder
                ideeller Art beziehen, grundsätzlich ausgeschlossen, sofern seitens des Landratsamtes Waldshut kein
                vorsätzliches oder grob fahrlässiges Verschulden vorliegt. Eine Haftung für etwaige Schäden, die beim
                Aufrufen oder Herunterladen von Daten durch Schadsoftware oder der Installation oder Nutzung von
                Software verursacht werden, ist ausgeschlossen.
            </p>

            <h2>Haftung für Links</h2>
            <p>
                Das Angebot des Landratsamts Waldshut enthält „Links" (Querverweise) zu externen Webseiten Dritter, auf
                deren Inhalte kein Einfluss besteht. Trotz sorgfältiger inhaltlicher Kontrolle übernimmt das
                Landratsamt Waldshut deshalb keine Haftung für die Inhalte externer Links. Hierfür ist der jeweilige
                Anbieter oder Betreiber der verlinkten Seite verantwortlich. Für illegale, fehlerhafte oder
                unvollständige Inhalte und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung solcher
                Informationen entstehen, haftet jeweils alleine der Anbieter der Seite, auf welche verwiesen wird.
            </p>
            <p>
                Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung vom Landratsamt Waldshut auf mögliche
                Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
                Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist nicht möglich. Sobald das Landratsamt
                Waldshut aber von rechtswidrigen Handlungen oder Informationen Kenntnis erlangt, werden derartige
                Links unverzüglich entfernt. Das Landratsamt Waldshut distanziert sich ausdrücklich von allen Inhalten
                aller verlinkten Seiten, die nach der Linksetzung verändert wurden und von ihrer ursprünglichen
                Zielsetzung inhaltlich und/oder technisch abweichen. Auf den verlinkten Seiten veröffentlichte
                Meinungen und/oder Tatsachenbehauptungen macht sich das Landratsamt Waldshut durch die Schaltung des
                Links nicht zu eigen.
            </p>

            <h2>Urheberrecht</h2>
            <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
                Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
                Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors beziehungsweise
                Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch
                gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die
                Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten
                Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bittet das Landratsamt Waldshut um
                einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden derartige Inhalte
                umgehend entfernt.
            </p>
            <p>
                Das Layout der Seiten des Landratsamts Waldshut, die verwendeten Grafiken und Bilder, die Sammlung
                sowie die einzelnen Beiträge sind urheberrechtlich geschützt. Alle Rechte, auch die der
                fotomechanischen Wiedergabe, der Vervielfältigung und der Verbreitung mittels besonderer Verfahren
                (zum Beispiel Datenverarbeitung, Datenträger und Datennetze), auch teilweise, behält sich das
                Landratsamt Waldshut vor. Für etwaige Satzfehler sowie für die Richtigkeit der Eintragungen übernimmt
                das Landratsamt Waldshut keine Gewähr.
            </p>

            <h2>Elektronische Kommunikation / sichere Übermittlung</h2>

            <h3>Allgemeine Grundsätze der elektronischen Kommunikation</h3>
            <p>
                Das Landratsamt Waldshut bietet die Möglichkeit zur elektronischen Kommunikation an. Für den Bereich
                der Verwaltungsverfahren richtet sich die elektronische Kommunikation nach § 3a des
                Baden-Württembergischen Landesverwaltungsverfahrensgesetzes (LVwVfG). Danach ist die Übermittlung
                elektronischer Dokumente zulässig, soweit der Empfänger hierfür einen Zugang eröffnet hat.
            </p>
            <p>
                Das Landratsamt Waldshut hat diesen Zugang nach Maßgabe der folgenden technischen Rahmenbedingungen
                für die elektronische Kommunikation eröffnet. Wird von Ihnen der Kommunikationsaustausch per E-Mail
                begonnen, geht das Landratsamt Waldshut davon aus, dass auch Ihrerseits ein solcher Zugang eröffnet
                wurde und deshalb die gesamte Kommunikation auf diesem Wege stattfinden kann, soweit andere
                Vorschriften dem nicht entgegenstehen.
            </p>

            <h3>Formfreie Kommunikation</h3>
            <p>
                Für eine formfreie Kommunikation (hier ist eine eigenhändige Unterschrift, also die Schriftform, nicht
                zwingend vorgeschrieben) wurde folgende E-Mail-Adresse eingerichtet:{' '}
                <a href="mailto:post@landkreis-waldshut.de">post@landkreis-waldshut.de</a>.
            </p>
            <p>
                Formfreie E-Mails können zudem auch an alle auf{' '}
                <a href="https://www.landkreis-waldshut.de" target="_blank" rel="noopener noreferrer">
                    www.landkreis-waldshut.de
                </a>{' '}
                angebotenen oder auf Briefköpfen des Landratsamtes Waldshut ausgewiesenen E-Mail-Adressen gesendet
                werden.
            </p>
            <p>
                Es wird darauf hingewiesen, dass beim Versand einer einfachen E-Mail an das Landratsamt Waldshut eine
                unbefugte Kenntnisnahme oder Verfälschung auf dem Übertragungsweg nicht ausgeschlossen werden kann.
                Falls Sie dem Landratsamt Waldshut vertrauliche Informationen senden wollen, ist es empfehlenswert,
                hierzu die Briefpost zu verwenden.
            </p>
            <p>
                Möchten Sie E-Mails mit Dateianhängen an die Verwaltung versenden, so beachten Sie bitte, dass die
                Verwaltung nicht alle auf dem Markt gängigen Dateiformate und Anwendungen unterstützen kann. Folgendes
                Dateiformat kann verarbeitet werden:
            </p>
            <ul>
                <li>Portable Document Format (.pdf)</li>
            </ul>
            <p>
                Verwenden Sie abweichende Dateiformate, so kann die E-Mail unter Umständen nicht bearbeitet werden.
                Die Obergrenze bei der Dateigröße zur Annahme liegt bei 10 MB (10.240 KB) je einzelner E-Mail, größere
                Dateizusendungen per E-Mail werden bereits seitens unseres Internetproviders abgewiesen.
            </p>
            <p>
                Sofern eine E-Mail nicht verarbeitet werden kann, werden Sie durch den Empfänger darüber informiert.
                Dieser Fall kann z.B. durch Computerviren, allgemeine technische Probleme oder Abweichungen von den
                vorstehenden technischen Rahmenbedingungen ausgelöst werden.
            </p>

            <h3>Formgebundene Kommunikation</h3>
            <p>
                Bei der formgebundenen Kommunikation ist grundsätzlich die eigenhändige Unterschrift, also die
                Schriftform, vorgeschrieben.
            </p>
            <p>
                Dokumente, die dem Schriftformerfordernis unterliegen (z.B. der Widerspruch gegen einen Bescheid),
                können nicht per einfacher E-Mail, sondern nur mit einer gültigen qualifizierten elektronischen
                Signatur nach der eIDAS-Verordnung an die folgende E-Mail-Adresse geschickt werden:{' '}
                <a href="mailto:post@landkreis-waldshut.de">post@landkreis-waldshut.de</a>.
            </p>
            <p>
                Zur Sicherung der Vertraulichkeit Ihrer Mitteilungen können Sie über die oben genannte E-Mail-Adresse
                verschlüsselte Nachrichten an uns senden. Unterstützt wird die S/MIME-Verschlüsselung. Hierfür
                benötigen Sie unseren sogenannten „öffentlichen Schlüssel". Dieser steht als CER-Datei zum Download
                bereit. (Sollten Sie eine Fehlermeldung erhalten: Speichern Sie die Datei lokal und starten Sie die
                Installation von dort.)
            </p>
            <p>
                Sollten bei der Entschlüsselung Ihrer Nachrichten Schwierigkeiten auftreten, werden wir uns mit Ihnen
                per E-Mail oder in geeigneter Weise in Verbindung setzen.
            </p>
            <p>
                Bitte nutzen Sie zur Übermittlung sensibler oder verschlüsselungsbedürftiger Daten die auf der Website
                angegebenen sicheren Übermittlungswege (z. B. Verschlüsselungs- oder Upload-Dienste):{' '}
                <a href="https://austausch.landkreis-waldshut.de" target="_blank" rel="noopener noreferrer">
                    https://austausch.landkreis-waldshut.de
                </a>
            </p>
        </div>
    );
};

export default Impressum;
